import { render } from "./dialogdelete.vue?vue&type=template&id=1c060bf3"
import script from "./dialogdelete.vue?vue&type=script&lang=js"
export * from "./dialogdelete.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__